import { useCallback } from 'react';
import { Column } from '../../../../components/DataTable/DataTable';
import { exportData } from '../../../../services/exportService';
import { buildExportFileName } from './reportUtils';

export function useReportExport<T extends Record<string, unknown>>(
  rows: T[],
  columns: Column<T>[],
  entityName: string,
  fileBase: string,
  dateTo?: string,
) {
  const exportDisabled = rows.length === 0;

  const onExportExcel = useCallback(async () => {
    await exportData({
      format: 'excel',
      data: {
        sortedData: rows,
        tableColumns: columns,
        entityName,
        exportFileName: buildExportFileName(fileBase, dateTo),
      },
    });
  }, [rows, columns, entityName, fileBase, dateTo]);

  const onExportPDF = useCallback(async () => {
    await exportData({
      format: 'pdf',
      data: {
        sortedData: rows,
        tableColumns: columns,
        entityName,
        exportFileName: buildExportFileName(fileBase, dateTo),
      },
    });
  }, [rows, columns, entityName, fileBase, dateTo]);

  return { onExportExcel, onExportPDF, exportDisabled };
}
